module.exports = __webpack_public_path__ + "assets/img/image03.46fa6fbd.png";